import type { FaireProductEntity } from "../../entity_types/product";

export const p_59ef23xfg4: FaireProductEntity = {
  token: "p_59ef23xfg4",
  type: "product",
  name: "Après Ski Soy Candle - Holiday Collection",
  brandToken: "b_yynur8ww",
  brandName: "Good & Well Supply Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/9bbba1b9e8e9104ff313141708a8deee431e91f67fed29321e8445f9bab85c6e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/201b74f2998d7f85137a4e31f84044d228e328b965c2485a36807bfab5840e88.png",
    "https://cdn.faire.com/fastly/531598d9be5973e4392f3ef9d5aa2df9141668828948b9afcdbcc59bb8584206.png",
  ],
  priceDollars: 13,
  description:
    "Scent Notes: Cedar · Spice · Amber\nThe Vibe: Last run. First drink.\n\nThe mountain day is over, but the best part is just beginning. Après Ski captures the warmth of a bustling ski lodge, where boots are drying by the fire and everyone is trading stories from the slopes.\n\nCedar and amber create a rich, cozy base, while spice adds a welcome touch of warmth. Relaxed, inviting, and built for winter adventures.\n\nDiameter: 3 in\nHeight: 3 in\nApprox. Net Wt: 7 oz \nApprox. Burn time: 40+ hours\nPhthalate Free\nMade in USA\n\nGood & Well Supply Co. crafts clean candles that celebrate the human connection with nature and inspire exploration. We donate 1% of our annual revenue to nonprofit organizations that protect and conserve national parks and public lands and promote inclusion in the outdoors.\n\nTESTER POLICY:\nLimited to one tester per scent. Testers are 2-oz candles with an easy-to-remove lid for in-store smelling.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:20.957Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
